export default __webpack_public_path__ + "static/media/straightKnife.5a61ae3e.png";